// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnimatedRightPanel__member-list-exit-f470d4 {
  width: 360px;
}

.AnimatedRightPanel__member-list-exit-active-a1bf12 {
  width: 0;
  transition: width 100ms ease-out;
  background-color: var(--addition-80);
}

.AnimatedRightPanel__member-list-enter-e40a0d {
  width: 0;
}

.AnimatedRightPanel__member-list-enter-active-b7173d {
  width: 360px;
  transition: width 100ms ease-out;
  background-color: var(--addition-80);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/AnimatedRightPanel/AnimatedRightPanel.transitions.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,QAAA;EACA,gCAAA;EACA,oCAAA;AACF;;AAEA;EACE,QAAA;AACF;;AAEA;EACE,YAAA;EACA,gCAAA;EACA,oCAAA;AACF","sourcesContent":[".member-list-exit {\n  width: 360px;\n}\n\n.member-list-exit-active {\n  width: 0;\n  transition: width 100ms ease-out;\n  background-color: var(--addition-80);\n}\n\n.member-list-enter {\n  width: 0;\n}\n\n.member-list-enter-active {\n  width: 360px;\n  transition: width 100ms ease-out;\n  background-color: var(--addition-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"member-list-exit": `AnimatedRightPanel__member-list-exit-f470d4`,
	"memberListExit": `AnimatedRightPanel__member-list-exit-f470d4`,
	"member-list-exit-active": `AnimatedRightPanel__member-list-exit-active-a1bf12`,
	"memberListExitActive": `AnimatedRightPanel__member-list-exit-active-a1bf12`,
	"member-list-enter": `AnimatedRightPanel__member-list-enter-e40a0d`,
	"memberListEnter": `AnimatedRightPanel__member-list-enter-e40a0d`,
	"member-list-enter-active": `AnimatedRightPanel__member-list-enter-active-b7173d`,
	"memberListEnterActive": `AnimatedRightPanel__member-list-enter-active-b7173d`
};
module.exports = ___CSS_LOADER_EXPORT___;
